import classNames from 'classnames'
import React from 'react'
import styles from './PageWrapper.module.css'

export const PageWrapper = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return <div className={classNames(styles.root, className)}>{children}</div>
}
